import React from "react";
import { INTEGRATION_LOGOS } from "../marketingData";

const LogosMarquee = () => {
  const chips = [];
  for (let i = 0; i < 4; i += 1) {
    INTEGRATION_LOGOS.forEach((name, idx) => {
      chips.push({ name, variant: idx % 2 === 0 ? "bk" : "og" });
    });
  }

  return (
    <div
      className="logos-section"
      style={{
        padding: 0,
        overflow: "hidden",
        background: "#f9f8f6",
        borderTop: "1px solid #e8e6e1",
        borderBottom: "1px solid #e8e6e1",
      }}
    >
      <div
        style={{
          textAlign: "center",
          fontSize: 11,
          fontWeight: 600,
          color: "#bbb",
          letterSpacing: "0.12em",
          textTransform: "uppercase",
          padding: "28px 0 16px",
        }}
      >
        Integrates with
      </div>
      <div className="marquee-outer" style={{ overflow: "hidden", position: "relative", paddingBottom: 28 }}>
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            width: 70,
            background: "linear-gradient(to right,#f9f8f6,transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
        <div
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            width: 70,
            background: "linear-gradient(to left,#f9f8f6,transparent)",
            zIndex: 2,
            pointerEvents: "none",
          }}
        />
        <div
          className="marquee-track"
          style={{
            display: "flex",
            alignItems: "center",
            gap: 10,
            width: "max-content",
            animation: "marqueeScroll 24s linear infinite",
            padding: "4px 8px",
          }}
        >
          {chips.map((chip, i) => (
            <div className={`logo-chip ${chip.variant}`} key={`${chip.name}-${i}`}>
              {chip.name}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LogosMarquee;
